import { BrainCircuit, type LucideIcon } from 'lucide-react'

export type PlatformMenuItem = {
  id: string
  labelKey: string
  defaultLabel: string
  href: string
  icon: LucideIcon
  /** Permission gate */
  requires: 'deploy' | 'recipes'
}

/**
 * Org-level catalogue entries (Studio tree leaf « Modèles »).
 * Agent-scoped surfaces (MCP, Skills, keys, data, …) live under each Agent.
 */
export const PLATFORM_MENU_ITEMS: PlatformMenuItem[] = [
  {
    id: 'platform-llm',
    labelKey: 'sidebar.models',
    defaultLabel: 'Modèles',
    href: '/studio/llm',
    icon: BrainCircuit,
    requires: 'deploy',
  },
]

export function filterPlatformMenuItems({
  canDeploy,
  canWriteRecipes,
}: {
  canDeploy: boolean
  canWriteRecipes: boolean
}): PlatformMenuItem[] {
  return PLATFORM_MENU_ITEMS.filter((item) => {
    if (item.requires === 'recipes') return canWriteRecipes
    return canDeploy
  })
}
